import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Loader } from '../../../../components/Loader/Loader';
import { axiosInstance } from '../../../../helpers/axios';
import { IArticle } from '../../../../types/types';
import { ArticleForm } from '../ArticleForm/ArticleForm';
import styles from '../ArticleForm/ArticleForm.module.scss';

export const EditArticle = () => {
    const { id } = useParams();
    const [article, setArticle] = useState<IArticle | null>(null);

    useEffect(() => {
        axiosInstance
            .get(`/v1/article/${id}/`)
            .then((response) => setArticle(response.data))
            .catch(() => toast.error('Не удалось загрузить материал'));
    }, [id]);

    // форма и редактор заполняются один раз при создании, поэтому ждём материал
    return article ? (
        <ArticleForm key={article.id} article={article} />
    ) : (
        <div className={styles.loader}>
            <Loader />
        </div>
    );
};
